import { Divider, Grid, useMediaQuery } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import popupStyle from "../../../../../../assets/styles/componentStyles/callAnalysisStyles/callAnalysisAudio.module.scss";
import globalStyles from "../../../../../../assets/styles/global.module.scss";
import styles from "../../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowCreate.module.scss";
import GlobalButton from '../../../../../utility/globalButton/button';
import { UserContext, UserContextPayload } from '../../../../../../context/userContext';
import agent from '../../../../../../services/api';
import { chatbotDataConnector, dataConnectorList, functionParameterData, functionResponseData } from '../../../../../../models/axiosModel';
import CustomAPIConfig from './customAPIConfig';
import { FlowBuilderContext, FlowBuilderContextPayload } from '../../../../../../context/flowBuilderContext';
import { generateUUID, isSystemApi, WHATSAPP_PAYMENT_INFO_SYSTEM_API } from '../../../../../../utils/constants';
import { WorkflowContext, WorkflowContextPayload } from '../../../../../../context/workflowContext';
import { isCurrentViewVersionPublished } from '../../../utilityFunctions';

export interface metaDataType {
    metadata_type_id: string
}
export interface functionParameters {
    function_parameter_data_id: number,
    action_custom_api_call_request_variable_id: string | null,
    function_parameter_fallback_value: string,
    function_parameter_name: string,
    function_parameter_name_path: string,
    chatbot_custom_variable_configuration_id: string | null,
    metadata_type?: any,
    variable_type?: any
}

export interface functionResponse {
    function_response_data_id: number,
    action_custom_api_call_response_variable_id: string | null,
    function_response_fallback_value: string,
    function_response_name: string,
    function_response_name_path: string,
    chatbot_custom_variable_configuration_id: string | null,
    action_custom_api_call_response_variable_path: string,
}

export interface createWebhookPayload {
    chatbot_data_connector_id: number | null,
    function_parameters: functionParameters[],
    function_response: functionResponse[],
}

const CustomAPIConfigPopup = (props: any) => {

    const { actionData, stepAction, setFlagWebhookPopup } = props;
    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;

    const { onChangeCurrentActiveNodeConfig, nodes, onBlurOfFallBackOfBtnVar, currentActiveNodeConfig } = useContext(FlowBuilderContext) as FlowBuilderContextPayload
    const { currentActiveStaticWorkflow } = useContext(WorkflowContext) as WorkflowContextPayload

    const [tempActionData, setTempActionData] = useState(actionData)

    const [dataConnectorList, setDataConnectorList] = useState<dataConnectorList[]>([]);
    const [dataConnectorDetails, setDataConnectorDetails] = useState<chatbotDataConnector[]>([]);

    const [flagShowResponseData, setFlagShowResponseData] = useState<boolean>(false);

    const [payload, setPayload] = useState<createWebhookPayload>({
        chatbot_data_connector_id: null,
        function_parameters: [],
        function_response: [],
    });

    const largeScreen = useMediaQuery('(max-width : 1600px) and (min-width : 0px)');

    const extractResponsePaths = (data: functionResponseData[]) => {
        const idMap = new Map();
        data?.forEach(item => idMap.set(item.function_response_data_id, item));

        function buildPathAndArrayFlag(item: functionResponseData) {
            const pathParts = [];
            let insideArray = false;

            let current = item;
            let parent = idMap.get(current.parent_function_response_data_id);

            // Traverse all the way to the root (null parent)
            while (parent) {
                const currentType = parent.function_parameter_type_name;
                const grandParent = idMap.get(parent.parent_function_response_data_id);
                const grandParentType = grandParent?.function_parameter_type_name;

                if (currentType === 'array') {
                    insideArray = true;
                    pathParts.unshift(`[INDEX]`);
                    pathParts.unshift(`["${parent.function_response_name}"]`);
                } else if (
                    currentType !== 'object' || // always include non-object
                    (currentType === 'object' && grandParentType !== 'array') // include object if its parent is not array
                ) {
                    pathParts.unshift(`["${parent.function_response_name}"]`);
                }

                current = parent;
                parent = idMap.get(current.parent_function_response_data_id);
            }

            pathParts.unshift("json");
            pathParts.push(`["${item.function_response_name}"]`);

            return {
                path: pathParts.join(''),
                insideArray,
            };
        }

        return data
            ?.filter(item =>
                item.function_parameter_type_name === 'string' || item.function_parameter_type_name === 'number'
            )
            ?.map(item => {
                const { path, insideArray } = buildPathAndArrayFlag(item);
                return {
                    ...item,
                    path,
                    insideArray,
                };
            });
    }

    const filterAndSortFunctionParameterData = (functionParameterData: any, flagRender: boolean) => {
        let filteredAndSortedData = functionParameterData?.filter((param: functionParameterData) => (param?.function_parameter_type_name == "string" || param?.function_parameter_type_name == "number"))?.sort((a: any, b: any) => a?.function_parameter_data_id - b?.function_parameter_data_id);
        if(flagRender && isSystemApi(dataConnectorDetails?.[0]?.chatbot_data_connector_function_path) && dataConnectorDetails?.[0]?.data_connector_functions?.data_connector_function_name?.toLowerCase() === WHATSAPP_PAYMENT_INFO_SYSTEM_API?.toLowerCase()){
            filteredAndSortedData = filteredAndSortedData?.filter((param: functionParameterData) => param?.function_parameter_name?.toLowerCase() != 'whatsapp_template_id');
        }
        return filteredAndSortedData;
    }

    const getChatbotDataConnectorDetailCall = async (connector_id: number, flagUpdatePayloadFromActionData: boolean, flagUpdtePayload: boolean) => {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
        const response = await agent.getDataConnectorDetail.get(connector_id)
        if (response.status) {
            setDataConnectorDetails(response.data);
            if (flagUpdtePayload) {
                if (flagUpdatePayloadFromActionData) {
                    setPayload((prevState) => ({
                        ...prevState,
                        chatbot_data_connector_id: connector_id,
                        function_parameters: filterAndSortFunctionParameterData(response.data?.[0]?.data_connector_functions?.data_connector_function_parameters?.function_parameter_data, false)?.map((para: any) => {
                            // const alreadyConfigured = actionData?.action_custom_api_call_request_variable_data?.find((variable: any) => variable?.function_parameter_data_id == para?.function_parameter_data_id);
                            const alreadyConfigured = actionData?.action_custom_api_call_request_variable_data?.find((variable: any) => ((variable?.function_parameter_name == para?.function_parameter_name) && (variable?.function_parameter_name_path == para?.function_parameter_name_path)));
                            return {
                                function_parameter_data_id: para?.function_parameter_data_id,
                                action_custom_api_call_request_variable_id: alreadyConfigured ? alreadyConfigured?.action_custom_api_call_request_variable_id : generateUUID(),
                                function_parameter_fallback_value: alreadyConfigured ? alreadyConfigured?.fallback_value : "",
                                function_parameter_name: para?.function_parameter_name || "",
                                function_parameter_name_path: para?.function_parameter_name_path || "",
                                chatbot_custom_variable_configuration_id: alreadyConfigured ? alreadyConfigured?.chatbot_custom_variable_configuration?.chatbot_custom_variable_configuration_id : null,
                                variable_type: alreadyConfigured ? alreadyConfigured?.variable_type : null,
                                metadata_type: alreadyConfigured ? alreadyConfigured?.metadata_type : null,
                            }
                        }),
                        function_response: extractResponsePaths(response.data?.[0]?.data_connector_functions?.data_connector_function_response?.function_response_data)?.sort((a: any, b: any) => a?.function_response_data_id - b?.function_response_data_id)?.map((para: any) => {
                            // const alreadyConfigured = actionData?.action_custom_api_call_response_variable_data?.find((variable: any) => variable?.function_response_data_id == para?.function_response_data_id);
                            const alreadyConfigured = actionData?.action_custom_api_call_response_variable_data?.find((variable: any) => ((variable?.function_response_name == para?.function_response_name) && (variable?.function_response_name_path == para?.function_response_name_path)));
                            return {
                                function_response_data_id: para?.function_response_data_id,
                                action_custom_api_call_response_variable_id: alreadyConfigured ? alreadyConfigured?.action_custom_api_call_response_variable_id : generateUUID(),
                                function_response_fallback_value: alreadyConfigured ? alreadyConfigured?.fallback_value : "",
                                function_response_name: para?.function_response_name,
                                function_response_name_path: para?.function_response_name_path,
                                chatbot_custom_variable_configuration_id: alreadyConfigured ? alreadyConfigured?.chatbot_custom_variable_configuration?.chatbot_custom_variable_configuration_id : null,
                                action_custom_api_call_response_variable_path: alreadyConfigured ? alreadyConfigured?.action_custom_api_call_response_variable_path : para?.path
                            }
                        })
                    }))
                } else {
                    setPayload((prevState) => ({
                        ...prevState,
                        chatbot_data_connector_id: connector_id,
                        function_parameters: filterAndSortFunctionParameterData(response?.data?.[0]?.data_connector_functions?.data_connector_function_parameters?.function_parameter_data ?? [], false)?.map((para: functionParameterData) => {
                            return {
                                function_parameter_data_id: para.function_parameter_data_id,
                                action_custom_api_call_request_variable_id: generateUUID(),
                                function_parameter_name: para.function_parameter_name,
                                function_parameter_name_path: para?.function_parameter_name_path ?? '',
                                function_parameter_fallback_value: "",
                                chatbot_custom_variable_configuration_id: null,
                            }
                        }),
                        function_response: [],
                    }))
                }
            } else {
                setPayload((prevState) => ({
                    ...prevState,
                    function_parameters: prevState.function_parameters?.map((para: functionParameters) => ({
                        ...para,
                        function_parameter_name: response.data?.[0]?.data_connector_functions?.data_connector_function_parameters?.function_parameter_data?.find((param: any) => param.function_parameter_data_id == para.function_parameter_data_id)?.function_parameter_name || "",
                    })),
                    function_response: prevState.function_response?.map((para: functionResponse) => ({
                        ...para,
                        function_response_name: response.data?.[0]?.data_connector_functions?.data_connector_function_response?.function_response_data?.find((param: any) => param.function_response_data_id == para.function_response_data_id)?.function_response_name || "",
                    }))
                }))
            }
        } else {
            handleError(response);
        }
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
    }

    const disabledSaveBtn = () => {
        if (payload.chatbot_data_connector_id && dataConnectorDetails.length > 0) {
            for (let i = 0; i < payload.function_parameters?.length; ++i) {
                const currentVar = payload.function_parameters[i];
                if (!(currentVar.chatbot_custom_variable_configuration_id) && !(currentVar.function_parameter_fallback_value?.trim()?.length > 0) && !(currentVar?.metadata_type)) {
                    return true;
                }
            }
            // if(flagShowResponseData){
            //     for(let i = 0; i < payload.function_response?.length; ++i){
            //         const currentVar = payload.function_response[i];
            //         if(!(currentVar.chatbot_custom_variable_configuration_id) && !(currentVar.function_response_fallback_value?.trim()?.length > 0)){
            //             return true;
            //         }
            //     }
            // }
            return false;
        } else {
            return true;
        }
    }

    const handleSaveClick = () => {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
        const updated_action_data = {
            action_custom_api_call_id: actionData?.action_custom_api_call_id ? actionData?.action_custom_api_call_id : generateUUID(),
            data_connector: {
                chatbot_data_connector_id: payload.chatbot_data_connector_id
            },
            action_custom_api_call_request_variable_data: payload.function_parameters?.map((para) => {
                return {
                    action_custom_api_call_request_variable_id: para.action_custom_api_call_request_variable_id,
                    function_parameter_data_id: para.function_parameter_data_id,
                    function_parameter_name: para.function_parameter_name,
                    function_parameter_name_path: para.function_parameter_name_path,
                    fallback_value: para.function_parameter_fallback_value || "",
                    chatbot_custom_variable_configuration: {
                        chatbot_custom_variable_configuration_id: para.chatbot_custom_variable_configuration_id
                    },
                    metadata_type: para.metadata_type,
                    variable_type: para.variable_type
                }
            }) || [],
            action_custom_api_call_response_variable_data: payload.function_response?.filter((res) => (res?.chatbot_custom_variable_configuration_id || res?.function_response_fallback_value?.trim()?.length > 0))?.map((res) => {
                return {
                    action_custom_api_call_response_variable_id: res.action_custom_api_call_response_variable_id,
                    function_response_data_id: res.function_response_data_id,
                    function_response_name: res.function_response_name,
                    function_response_name_path: res.function_response_name_path,
                    fallback_value: res.function_response_fallback_value || "",
                    chatbot_custom_variable_configuration: {
                        chatbot_custom_variable_configuration_id: res.chatbot_custom_variable_configuration_id
                    },
                    action_custom_api_call_response_variable_path: res.action_custom_api_call_response_variable_path
                }
            }) || []
        }
        onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id,
            updated_action_data,
            {
                updateType: "editExistingStepAction"
            }
        )
        onBlurOfFallBackOfBtnVar(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id,
            updated_action_data,
            {
                updateType: "editExistingStepAction"
            }
        );
        setFlagWebhookPopup(false);
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
    }

    const handleCancelClick = () => {
        // To Close the popup.
        setFlagWebhookPopup(false);

        // To Reset the data.
        // setPayload((prevState) => ({
        //     ...prevState,
        //     chatbot_data_connector_id: tempActionData.data_connector.chatbot_data_connector_id,
        //     function_parameters: tempActionData?.action_custom_api_call_request_variable_data?.sort((a: any, b: any) => a.function_parameter_data_id - b.function_parameter_data_id).map((para: any) => {
        //         return ({
        //             function_parameter_data_id: para.function_parameter_data_id,
        //             action_custom_api_call_request_variable_id: para.action_custom_api_call_request_variable_id,
        //             function_parameter_fallback_value: para.fallback_value,
        //             function_parameter_name: dataConnectorDetails?.[0]?.data_connector_functions?.data_connector_function_parameters?.function_parameter_data?.find((param: functionParameterData) => param.function_parameter_data_id == para.function_parameter_data_id)?.function_parameter_name || "",
        //             chatbot_custom_variable_configuration_id: para?.chatbot_custom_variable_configuration?.chatbot_custom_variable_configuration_id,
        //         })
        //     }) || [],
        //     function_response: tempActionData?.action_custom_api_call_response_variable_data?.sort((a: any, b: any) => a.function_response_data_id - b.function_response_data_id).map((para: any) => {
        //         return ({
        //             function_response_data_id: para.function_response_data_id,
        //             action_custom_api_call_response_variable_id: para.action_custom_api_call_response_variable_id,
        //             function_response_fallback_value: para.fallback_value,
        //             function_parameter_name: dataConnectorDetails?.[0]?.data_connector_functions?.data_connector_function_response?.function_response_data?.find((param: functionResponseData) => param.function_response_data_id == para.function_response_data_id)?.function_response_name || "",
        //             chatbot_custom_variable_configuration_id: para?.chatbot_custom_variable_configuration?.chatbot_custom_variable_configuration_id,
        //             action_custom_api_call_response_variable_path: para?.action_custom_api_call_response_variable_path,
        //         })
        //     }) || [],
        // }))
        // if (tempActionData?.action_custom_api_call_response_variable_data && tempActionData?.action_custom_api_call_response_variable_data?.length > 0) {
        //     setFlagShowResponseData(true);
        // } else {
        //     setFlagShowResponseData(false);
        // }
        // if (tempActionData.data_connector.chatbot_data_connector_id != payload.chatbot_data_connector_id && tempActionData.data_connector.chatbot_data_connector_id) {
        //     getChatbotDataConnectorDetailCall(tempActionData.data_connector.chatbot_data_connector_id, false, false);
        // }
    }

    useEffect(() => {
        if (currentActiveStaticWorkflow) {
            setDataConnectorList(currentActiveStaticWorkflow?.additional_data?.data_connectors);
        }
        if (actionData?.data_connector?.chatbot_data_connector_id) {
            getChatbotDataConnectorDetailCall(actionData?.data_connector?.chatbot_data_connector_id, true, true);
        }
        if (actionData?.action_custom_api_call_response_variable_data && actionData?.action_custom_api_call_response_variable_data?.length > 0) {
            setFlagShowResponseData(true);
        }
    }, [])

    return (
        <>
            <Grid container className={`${globalStyles.zIndex1} ${globalStyles.flexColumn}`} gap={"20px"} padding={"30px"} flexWrap={"nowrap"}>
                <Grid item className={`${globalStyles.fullwidth} ${globalStyles.textCenter}`}>
                    <span className={popupStyle.popupTitleStyle}>Custom API</span>
                </Grid>
                <Grid item>
                    <Divider style={{ opacity: "0.2", color: "#9D9D9D", border: "0.2px solid #9D9D9D" }} />
                </Grid>
                <Grid item className={`${globalStyles.fullwidth} ${styles.createWorkflowPopupScrollContainer}`}>
                    <CustomAPIConfig
                        dataConnectorList={dataConnectorList}
                        setDataConnectorList={setDataConnectorList}
                        dataConnectorDetails={dataConnectorDetails}
                        setDataConnectorDetails={setDataConnectorDetails}
                        payload={payload}
                        setPayload={setPayload}
                        getChatbotDataConnectorDetailCall={getChatbotDataConnectorDetailCall}
                        flagShowResponseData={flagShowResponseData}
                        setFlagShowResponseData={setFlagShowResponseData}
                        extractResponsePaths={extractResponsePaths}
                        filterAndSortFunctionParameterData={filterAndSortFunctionParameterData}
                    />
                </Grid>
                <Grid item className={`${globalStyles.fullwidth}`} mt={1}>
                    <Grid container direction={"row"} gap={2} justifyContent={"center"}>
                        <Grid item>
                            <GlobalButton
                                buttonText={"Cancel"}
                                className='borderedButtonStyle'
                                sx={{ minWidth: "130px", fontSize: largeScreen ? "13px !important" : "" }} 
                                disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                onClick={() => {
                                    handleCancelClick();
                                }}
                            />
                        </Grid>
                        <Grid item>
                            <GlobalButton
                                buttonText={"Save"}
                                className='primaryButtonStyle'
                                sx={{ minWidth: "130px" }}
                                disabled={disabledSaveBtn() || isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                onClick={() => {
                                    handleSaveClick();
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default CustomAPIConfigPopup
